/**
 * Cycle Why Buy subtitle USPs. The <details> bar stays the click target.
 */
(function (root) {
  'use strict';
  var INTERVAL_MS = 3000;
  var ROOT_SEL = '[data-d1-why-rotator]';
  var ITEM_SEL = '[data-d1-why-rotator-item]';

  function nextIndex(count, current) {
    if (count < 1) return 0;
    return (current + 1) % count;
  }

  function shouldTick(open, reducedMotion) {
    return !open && !reducedMotion;
  }

  function prefersReducedMotion() {
    return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function show(items, index) {
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('is-active', i === index);
    }
  }

  function bind(rotator) {
    var items = rotator.querySelectorAll(ITEM_SEL);
    if (items.length < 2) return;
    var details = rotator.closest('details');
    var index = 0;
    var timer = null;

    function stop() {
      if (timer) root.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (timer) return;
      if (!shouldTick(details && details.open, prefersReducedMotion())) return;
      timer = root.setInterval(function () {
        index = nextIndex(items.length, index);
        show(items, index);
      }, INTERVAL_MS);
    }

    show(items, 0);
    if (details) {
      details.addEventListener('toggle', function () {
        if (details.open) stop();
        else start();
      });
    }
    start();
  }

  function startAll() {
    var nodes = root.document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < nodes.length; i++) bind(nodes[i]);
  }

  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', startAll);
    } else {
      startAll();
    }
  }

  root.D1WhyMiniRotator = {
    INTERVAL_MS: INTERVAL_MS,
    nextIndex: nextIndex,
    shouldTick: shouldTick,
  };
})(typeof window !== 'undefined' ? window : globalThis);
